/**
 * BridgeWalletContext context instance and type definition.
 * Separated from BridgeWalletContext.tsx so hooks can live in their own file
 * without triggering react-refresh/only-export-components warnings.
 */

import { createContext } from 'react';
import type { ActiveAccountType, Chain } from 'types';

export type NetworkType = 'ethereum' | 'casper';

export interface BridgeWalletContextType {
  // Casper wallet
  casperAccount: ActiveAccountType | null;
  casperConnected: boolean;
  casperSignIn: () => void;

  // Ethereum wallet
  ethereumAddress: string | undefined;
  ethereumConnected: boolean;
  ethereumOpenConnectModal: () => void;
  ethereumDisconnect: () => void;

  // Selected EVM chain
  selectedChain: Chain | null;
  selectedChainId: number | null;
  selectedChainName: string | undefined;
  setSelectedChain: (chain: Chain) => void;

  // Combined state
  bothWalletsConnected: boolean;
  isWrongNetwork: boolean;
  switchToSelectedChain: () => Promise<void>;

  // Helper to get address for a network
  getAddressForNetwork: (network: NetworkType) => string | undefined;

  // Chain-specific helpers
  getLockerAddress: () => string | undefined;
  getExplorerTxUrl: (txHash: string) => string;
}

export const BridgeWalletContext = createContext<BridgeWalletContextType | null>(null);
